import styles from "@/styles/modules/components/contact/ModuleFaqs.module.scss";
import ModuleFaqsFaq from "./ModuleFaqsFaq";

interface ModuleFaqs {
  title: string | null;
  faqs:
    | {
        title: string | null;
        text: string | null;
      }[]
    | null;
}

export default function ModuleFaqs({ title, faqs }: ModuleFaqs) {
  return (
    <section className={styles.moduleFaqs} id="faq">
      <div className={styles.moduleFaqsContainer}>
        {title && <h2 data-aos="fadeIn">{title}</h2>}
        <div className={styles.faqs}>
          {faqs &&
            faqs.map((faq, i) => (
              <ModuleFaqsFaq
                key={i}
                fkey={i}
                title={faq.title || ""}
                text={faq.text || ""}
              />
            ))}
        </div>
      </div>
    </section>
  );
}
